module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Commode2-dbfea3050672c97c4684c64dab26dc1d.svg";